<template>
  <div class="request-cart" v-track-page="'yd_requirement_list'">
    <van-tabs
      align="center"
      :show-dividing-line="true"
      v-model="activeDrugStatus"
      sticky
      v-if="orderList.length"
      @change="handleChangeTab"
    >
      <van-tab v-for="(item, key) in ['药品', '非药品']" :name="`${(key + 1) % 2}`" :title="item" :key="item"></van-tab>
    </van-tabs>
    <van-checkbox-group v-model="checked" :max="activeDrugStatus == '0' ? 120 : 5" ref="drugCheck">
      <div v-for="(item, key) in orderList.filter((i) => i.isDrug == activeDrugStatus)" :key="key.itemId">
        <van-swipe-cell>
          <div class="flex">
            <van-checkbox
              :disabled="item.stockNum === 0"
              :name="item.itemId"
              @click="handleClick(item.itemId, item, activeDrugStatus == '0' ? 120 : 5)"
              class="check-request flex center"
            ></van-checkbox>
            <div class="product-item-re">
              <product-item :item="item" @handleDelete="handleDelete"></product-item>
            </div>
          </div>

          <template #right>
            <div @click="del(item)" class="delete-button">删除</div>
          </template>
        </van-swipe-cell>
      </div>
    </van-checkbox-group>
    <van-empty
      v-if="isShowEmpty && !load"
      description="暂无商品"
      image="https://static.91jkys.com/attachment/20211021101256064_c7a906b021bc4f839e3e9fd8c02c9236.png"
    ></van-empty>
    <div class="h100"></div>
    <div class="fixed fixed-ios">
      <div class="tips">商品价格以实际下单界面为准</div>
      <div class="flex space-between align-center fix-content pl16 pr16">
        <div class="left" v-if="activeDrugStatus == 1">
          合计：
          <span class="price">{{ totalCountPrice | parsePrice }}</span>
        </div>
        <div class="left flex align-center" v-if="activeDrugStatus == 0">
          <van-checkbox v-model="checkedAll" label-disabled @change="handleCheckAll"></van-checkbox>
          <div class="price-container">
            <div class="flex align-center">
              <span>合计：</span>
              <div class="price-info">
                <div class="rmb">&yen;</div>
                <div class="price-txt">{{ totalCountPrice | price }}</div>
              </div>
            </div>
            <!-- <div class="fee-info">
              <span v-if="expreeFee.firstOrders">首单已享包邮</span>
              <span v-else-if="expreeFee.freeShippingAmount - totalCountPrice > 0">
                差
                <span class="pri">{{ (expreeFee.freeShippingAmount - totalCountPrice) | parsePrice }}</span>
                享受包邮（满
                <span class="pri">{{ expreeFee.freeShippingAmount | price }}</span>
                包邮）
              </span>
              <span v-else>
                已包邮（满
                <span class="pri">{{ expreeFee.freeShippingAmount | price }}</span>
                包邮）
              </span>
            </div> -->
          </div>
        </div>
        <van-button
          type="primary"
          size="mini"
          class="submit_button"
          v-reClick="submit"
          :disabled="!checked.length"
          v-track-event.click="'zyyd-click-SubmitOrder'"
        >
          去结算
          <span v-if="checked.length && activeDrugStatus == 0">({{ checked.length }})</span>
        </van-button>
        <van-popup
          v-model="diseasePopupVisible"
          round
          position="bottom"
          :close-on-click-overlay="true"
          :close-on-popstate="true"
          :overlay-style="{ zIndex: 2002 }"
        >
          <DiseasePopup 
            @close="handleDiseaseClose"
            @cross="handleDiseaseCross"
            @confirm="handleDiseaseConfirm"
          />
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import ProductItem from './components/productItem';
import jumpCenter from '@/mixins/jumpCenter';
import DiseasePopup from '@/pages/specification/components/DiseasePopup';

export default {
  name: 'requestCart',
  mixins: [jumpCenter],
  data() {
    return {
      checked: [],
      checkedAll: false, // 是否全选
      orderList: [],
      expreeFee: {
        firstOrders: false,
        freeShippingAmount: 0
      }, // 包邮信息 包括邮费 和  是否首单包邮
      load: false,
      activeDrugStatus: '1', // 0 非药品 1 药品
      diseasePopupVisible: false,
    };
  },
  components: {
    ProductItem,
    DiseasePopup
  },
  watch: {
    checked(val) {
      if (this.activeDrugStatus === '1') return;

      const len = this.orderList.filter((i) => i.isDrug == this.activeDrugStatus && i.stockNum && !i.status).length;

      if (len) this.checkedAll = this.checked.length === len;
    }
  },
  computed: {
    totalCountPrice() {
      return this.orderList.reduce(
        (pre, cur) => (this.checked.indexOf(cur.itemId) !== -1 ? pre + cur.realPrice * cur.amount : pre),
        0
      );
    },
    isShowEmpty() {
      const len = this.orderList.filter((i) => i.isDrug == this.activeDrugStatus).length;
      return !len;
    }
  },
  async created() {
    await this.fetchCartList();
    this.$nextTick(() => {
      this.initChecked();
    });

    this.fetchExpressFree(); // 获取包邮信息
  },
  mounted() {
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        // window.location.reload();
      }
    });
  },
  methods: {
    // 检查是否全选
    checkIsChoAll() {
      const len = this.orderList.filter((i) => i.isDrug == this.activeDrugStatus && i.stockNum && !i.status).length;

      if (len) this.checkedAll = this.checked.length == len;
    },
    // 初始化选中态
    initChecked() {
      // recentAddType 当前tab状态 ---志鹏 drugCheckedList noDrugCheckedList
      const recentAddType = window.localStorage.getItem('recentAddType');
      const { isDrug, itemList } = this.$route.query;
      if (recentAddType) {
        this.activeDrugStatus = recentAddType.toString();
      }
      if (isDrug || isDrug == 0) {
        this.activeDrugStatus = isDrug.toString();
        window.localStorage.setItem('recentAddType', isDrug.toString());
        this.storeDrugList(itemList);
      } else {
        this.getDrugList();
      }
      if (itemList) {
        this.checked = itemList.split(',').map((item) => {
          if (this.orderList.filter((ite) => ite.itemId === Number(item) && ite.stockNum && !ite.status)[0]) {
            return Number(item);
          }
        });
      }
    },
    storeDrugList(item = '') {
      window.localStorage.setItem('recentAddType', this.activeDrugStatus);
      if (this.activeDrugStatus == 1) {
        window.localStorage.setItem('drugCheckedList', item);
      } else {
        window.localStorage.setItem('noDrugCheckedList', item);
      }
    },
    getDrugList() {
      const storeDrug = window.localStorage.getItem('drugCheckedList') || '';
      const storeNoDrug = window.localStorage.getItem('noDrugCheckedList') || '';

      if (this.activeDrugStatus == 1) {
        this.checked = storeDrug
          ? storeDrug.split(',').map((item) => {
              if (this.orderList.filter((ite) => ite.itemId === Number(item) && ite.stockNum && !ite.status)[0]) {
                return Number(item);
              }
            })
          : [];
      } else {
        this.checked = storeNoDrug
          ? storeNoDrug.split(',').map((item) => {
              if (this.orderList.filter((ite) => ite.itemId === Number(item) && ite.stockNum && !ite.status)[0]) {
                return Number(item);
              }
            })
          : [];
      }
    },
    toggleCheckAll(checkedAll) {
      const orderList = this.orderList.filter((item) => item.isDrug == this.activeDrugStatus);
      this.checked = [];
      if (checkedAll) {
        orderList.map((item) => {
          if (item.stockNum && !item.status) {
            this.checked.push(item.itemId);
          }
        });
      }
      this.storeDrugList(this.checked.join(','));
    },
    handleChangeTab() {
      window.localStorage.setItem('recentAddType', this.activeDrugStatus);
      this.getDrugList();
      // 每次切换 tab 都要清除选中的药品和非药品
      // this.checked = [];
      // this.checkedAll = false;
      // if (this.activeDrugStatus === '0') {
      //   this.checkedAll = true;
      //   this.toggleCheckAll(true);
      // }
    },
    // 非药品全选
    handleCheckAll() {
      const len = this.orderList.filter(
        (item) => item.isDrug == this.activeDrugStatus && item.stockNum && !item.status
      ).length;
      if (this.checkedAll) {
        this.toggleCheckAll(this.checkedAll);
      } else {
        if (this.checked.length === len) this.toggleCheckAll();
      }
    },
    handleDelete(itemId) {
      const inde = this.orderList.findIndex((item) => item.itemId === itemId);
      const delIndex = this.checked.indexOf(itemId);
      if (delIndex !== -1) this.checked.splice(delIndex, 1);

      if (inde !== -1) this.orderList.splice(inde, 1);
      this.storeDrugList(this.checked.join(','));
    },
    handleClick(id, item, num) {
      this.checkedAll =
        this.checked.length ===
        this.orderList.filter((i) => i.isDrug == this.activeDrugStatus && i.stockNum && !i.status).length;
      this.storeDrugList(this.checked.join(','));
      if (this.checked.length === num && this.checked.indexOf(id) === -1) {
        this.$toast(`单次最多提交${num}种`);
      }
    },
    del(item) {
      const { itemId, isDrug } = item;
      this.$dialog
        .confirm({
          title: '确认删除？',

          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {})
        .catch(() => {
          this.$fetch.deleteTrolley({ itemId, isDrug }).then(() => {
            this.handleDelete(itemId);
          });
        });
    },

    async fetchCartList() {
      this.load = true;
      const { trolleyList = [] } = await this.$fetch.fetchCartList();

      // const hasNoDrug = trolleyList && trolleyList.some((item) => item.isDrug === 0);

      this.orderList = trolleyList;
      this.checkIsChoAll();

      // 4.2.4 业务方要求：根据最后一次加入需求清单商品类别（药 || 非药）, 来默认展示不同tab，所以去除之前有非药就优先展示非药的限制。
      // if (hasNoDrug && this.activeDrugStatus === '0') {
      //   this.$nextTick(() => {
      //     this.toggleCheckAll(true);
      //   });
      // }

      this.load = false;
    },
    async fetchExpressFree() {
      const res = await this.$fetch.fetchExpressFree();

      this.expreeFee = res;
    },
    submit(diseaseDesc) {
      // submitTrolley
      const detail = this.orderList.filter((item) => this.checked.indexOf(item.itemId) !== -1);
      this.$fetch
        .submitTrolley({
          type: 'submitTrolley',
          detail,
          isDrug: parseInt(this.activeDrugStatus),
          version: 'version-supplier-1.1',
          diseaseDesc
        })
        .then(async (res) => {
          this.storeDrugList();
          const { status, requirementId, code, message } = res;

          if (code === 'item_down_sale_out') {
            await this.$toast({
              message,
              onClose: () => {
                this.fetchCartList();
                this.fetchExpressFree();
              },
              duration: 2000
            }); // 获取包邮信息
            return;
          }
          if (status === 1) {
            window.wx.closeWindow();
            return;
          }
          if (status === 3) {
            this.saveDataAndToPreOrder({
              isDrug: parseInt(this.activeDrugStatus),
              bizType: 'need',
              bizId: requirementId || ''
            });
            return;
          }
          this.$router.push({
            name: 'BindingDoctors',
            query: { requirementId, isDrug: parseInt(this.activeDrugStatus) }
          });
        })
        .catch(async (err) => {
          // TODO: 临时方案，报错并刷新当前页面
          if (this.activeDrugStatus === '0') {
            await this.$toast({
              message: err.message,
              onClose: () => {
                window.location.reload();
              },
              duration: 1000
            });
          }
        });
    },
    handleSubmitOrder() {
      if (this.activeDrugStatus == 1) {
        this.diseasePopupVisible = true;
      } else {
        this.submit();
      }
    },
    handleDiseaseConfirm(params) {
      this.submit(params);
    },
    handleDiseaseClose() {
      this.diseasePopupVisible = false;
    },
    handleDiseaseCross() {
      this.submit();
    }
  }
};
</script>

<style lang="scss" scoped>
.request-cart {
  ::v-deep.van-checkbox {
    overflow: visible;
  }
  .tips {
    background: #ebf8ff;
    padding: 13px 16px;
    border-bottom: 1px solid #eee;
    color: #1e8dff;
    font-size: 14px;
    line-height: 14px;
  }
  min-height: 100vh;
  background: #fff;
  // ::v-deep .van-icon {
  //   width: 1em;
  //   height: 1em;
  //   line-height: 1;
  // }
  padding: 0.01% 0;
  .fixed {
    position: fixed;

    bottom: 0;
    left: 0;
    width: 100%;
  }
  .h100 {
    height: 140px;
  }
  .fix-content {
    background: #fff;
    height: 60px;
  }
  .price-info {
    display: flex;
    align-items: baseline;

    .rmb {
      color: #ff4e47;
      font-size: 12px;
      transform: scale(0.9, 0.9);
      transform-origin: bottom;
      font-weight: 500;
      line-height: 1;
    }

    .price-txt {
      color: #ff4e47;
      font-size: 16px;
      line-height: 1;
      margin-right: 4px;
      font-weight: 500;
    }
  }
  .price-container {
    margin-left: 12px;

    .fee-info {
      margin-top: 4px;
      font-size: 12px;
      width: 110%;
      background: transparent;
      position: relative;
      left: -5%;
      transform: scale(0.9, 0.9);

      color: #8c8c8c;
      .pri {
        color: #f23400;
      }
    }
  }
  .left {
    font-size: 14px;
    color: #333;
    .price {
      font-size: 16px;
      font-weight: 500;
      color: #f23400;
    }
  }
  .submit_button {
    padding: 0;
    width: 125px;
    height: 44px;
    font-size: 16px;
    border-radius: 8px;
  }
}
.check-request {
  min-width: 10.6%;
  position: relative;
  height: 104px;
  top: 0px;
  left: 2%;
  // ::v-deep .van-checkbox__icon--checked {
  //   .van-icon {
  //     position: relative;
  //     &::before {
  //       position: absolute;
  //       font-size: 12px;
  //       top: 2px;
  //       left: 1px;
  //     }
  //   }
  // }
}
.product-item-re {
  width: 89.4%;
}
.delete-button {
  width: 60px;
  font-size: 16px;
  padding: 0;
  background: #e63d3d;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
